import store from "../store";
import { BUSINESS_UPDATE, ERROR_UPDATE, PRODUCT_INITIAL, PRODUCT_UPDATE } from "../store/slices";
import { DatabaseInstance } from "./databaseClass";
import { ImageInstance } from "./imageClass";

class VenueClass {
  constructor() { }

  public getMenu = async (id: string) => {
    try {
      store.dispatch(
        PRODUCT_UPDATE({
          data: {
            ...PRODUCT_INITIAL,
            isLoading: true,
          },
        }),
      );

      const data = {
        endpoint: `menus/getMenu/${id}`,
      };

      const menu = await DatabaseInstance.getRecord(data);
      const menuProducts = [];

      // loop through menu and set the products as the menu.product
      for (let i = 0; i < menu.length; i++) {
        const product = menu[i].product;
        menuProducts.push({
          ...product,
          createdAt: menu[i].createdAt,
        });
      }

      store.dispatch(
        PRODUCT_UPDATE({
          data: {
            ...store.getState().product,
            isLoading: false,
            products: menuProducts,
          },
        }),
      );
      //needed for comparison to brand products when pulling up modal. sorrrryyyy
      return menuProducts;
    } catch (error) {
      console.error(error);
    }
  };

  public removeMenuItem = async (venueId: string, productId: string) => {
    try {
      const data = {
        endpoint: `menus/deleteProduct?venueId=${venueId}&productId=${productId}`,
      };

      const response = await DatabaseInstance.deleteRecord(data);

      console.log("response", response);

      if (!response) {
        store.dispatch(
          ERROR_UPDATE({
            data: {
              ...store.getState().error,
              error: true,
              message: `Something went wrong removing the menu item. Please try again. "${response.message}"`,
            },
          }),
        );
        return;
      }

      store.dispatch(
        PRODUCT_UPDATE({
          data: {
            ...store.getState().product,
            products: store.getState().product.products.filter((product: any) => product.id !== productId),
          },
        }),
      );
      return;
    } catch (error: any) {
      console.error(error);
      // store.dispatch(
      //   ERROR_UPDATE({
      //     data: {
      //       ...store.getState().error,
      //       error: true,
      //       message: `Something went wrong removing the menu item. Please try again. "${error.response.data.error}"`
      //     }
      //   })
      // )
    }
  };

  public addMenuItem = async (venueId: string, product: Product) => {
    try {
      console.log("adding this product: ", product);
      const data = {
        data: {
          venueId,
          productId: product.id,
        },
        endpoint: `menus/addProduct?venueId=${venueId}&productId=${product.id}`,
      };

      const response = await DatabaseInstance.createRecord(data);

      console.log("response", response);

      if (!response) {
        store.dispatch(
          ERROR_UPDATE({
            data: {
              ...store.getState().error,
              error: true,
              message: `Something went wrong adding the menu item. Please try again. "${response.message}"`,
            },
          }),
        );
        return;
      }

      store.dispatch(
        PRODUCT_UPDATE({
          data: {
            ...store.getState().product,
            products: [...store.getState().product.products, product],
          },
        }),
      );
      return;
    } catch (error: any) {
      console.error(error);
    }
  };

  public updateVenue = async (oldData: any, newData: any) => {
    try {
      store.dispatch(
        BUSINESS_UPDATE({
          data: {
            ...store.getState().business,
            isLoading: true,
          },
        }),
      );
      const alteredData = this.checkForDifferencesInVenueData(oldData, newData);
      // let newAddress;

      // if city, state, street, or zip are different, then we need to update the address
      // if (
      //   alteredData.city ||
      //   alteredData.stateId ||
      //   alteredData.street ||
      //   alteredData.zip
      // ) {
      //   const states = store.getState().state.states;
      //   const alteredState = states.find(
      //     (state: any) => state.id === alteredData.stateId
      //   );
      //   const notAlteredState = states.find(
      //     (state: any) => state.id === oldData.stateId
      //   );

      //   newAddress = `${alteredData.street ? alteredData.street : oldData.street}, ${alteredData.city ? alteredData.city : oldData.city}, ${alteredData.stateId ? alteredState.abbr : notAlteredState.abbr}, ${alteredData.zip ? alteredData.zip : oldData.zip}`;

      //   alteredData.address = newAddress;
      // }

      // if alteredData includes displayUrl or avatarUrl, then we need to upload the image to the server and get the url
      if (alteredData.displayUrl) {
        const res = await ImageInstance.uploadImageToS3(alteredData.displayUrl, "venues", oldData.name, false);

        if (!res) {
          // TODO: RENDER AN ERROR MESSAGE IN THE UPLOAD IMAGE TO S3 FUNCTION
          return;
        }

        const fileKey = res.fileKey;

        alteredData.displayUrl = fileKey;
      }

      if (alteredData.avatarUrl) {
        const res = await ImageInstance.uploadImageToS3(alteredData.avatarUrl, "venues", oldData.name, true);

        if (!res) {
          return;
        }

        const fileKey = res.fileKey;

        alteredData.avatarUrl = fileKey;
      }

      console.log("alteredData: ", alteredData);

      // if the alteredData.name has trailing whitespace at the end, remove it
      if (alteredData.name) {
        alteredData.name = alteredData.name.replace(/\s+$/, "");
      }

      const data = {
        endpoint: `venues/update/${oldData.id}`,
        data: alteredData,
        headers: {
          actingasid: oldData.id,
          actingastype: "venue",
        },
      };

      const response = await DatabaseInstance.updateRecord(data);

      if (!response) {
        store.dispatch(
          ERROR_UPDATE({
            data: {
              ...store.getState().error,
              error: true,
              message: `Something went wrong updating the venue. Please try again. "${response.message}"`,
            },
          }),
        );
        return;
      }

      store.dispatch(
        BUSINESS_UPDATE({
          data: {
            ...store.getState().business,
            activeBusiness: {
              ...response,
            },
            isLoading: false,
          },
        }),
      );

      console.log("response", response);
      return response;
    } catch (error: any) {
      console.error(error);
    }
  };

  private checkForDifferencesInVenueData = (oldData: any, newData: any) => {
    console.log("oldData: ", oldData);
    console.log("newData: ", newData);
    const differences: { [key: string]: any } = {};

    const keys = Object.keys(oldData);

    for (let i = 0; i < keys.length; i++) {
      if (oldData[keys[i]] !== newData[keys[i]]) {
        differences[keys[i]] = newData[keys[i]];
      }
    }

    return differences;
  };
}

const VenueInstance = new VenueClass();

export { VenueInstance };
